import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';
import * as bootstrap from 'bootstrap';

@Directive({
  selector: '[confirmModal]',
  standalone:true
})
export class ConfirmModalDirective {
  @Input() message: string = 'Are you sure?'; // Default confirmation message
  @Input() okLabel: string = 'OK'; // Default "OK" label
  @Input() cancelLabel: string = 'Cancel'; // Default "Cancel" label
  @Output() confirmed = new EventEmitter<void>();

  constructor(private el: ElementRef) {}

  @HostListener('click')
  onClick() {
    this.openModal();
  }

  openModal() {
    // Create the modal element manually
    const modal = document.createElement('div');
    modal.classList.add('modal', 'fade');
    modal.setAttribute('tabindex', '-1');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-labelledby', 'confirmModalLabel');
    modal.setAttribute('aria-hidden', 'true');
    modal.setAttribute('data-bs-backdrop','static');

    // Add modal content
    const modalDialog = document.createElement('div');
    modalDialog.classList.add('modal-dialog','modal-dialog-centered');
    modalDialog.setAttribute('role', 'document');
    modal.appendChild(modalDialog);

    const modalContent = document.createElement('div');
    modalContent.classList.add('modal-content');
    modalDialog.appendChild(modalContent);

    const modalHeader = document.createElement('div');
    modalHeader.classList.add('modal-header');
    modalContent.appendChild(modalHeader);

    const modalTitle = document.createElement('h5');
    modalTitle.classList.add('modal-title');
    modalTitle.id = 'confirmModalLabel';
    modalTitle.textContent = 'Confirmation';
    modalHeader.appendChild(modalTitle);

    const closeButton = document.createElement('button');
    closeButton.classList.add('btn-close');
    closeButton.setAttribute('type', 'button');
    closeButton.setAttribute('data-bs-dismiss', 'modal');
    closeButton.addEventListener('click', () => this.closeModal(modal));
    modalHeader.appendChild(closeButton);

    const modalBody = document.createElement('div');
    modalBody.classList.add('modal-body');
    modalBody.textContent = this.message;
    modalContent.appendChild(modalBody);

    const modalFooter = document.createElement('div');
    modalFooter.classList.add('modal-footer');
    modalContent.appendChild(modalFooter);

    const cancelButton = document.createElement('button');
    cancelButton.classList.add('btn', 'btn-secondary');
    cancelButton.setAttribute('type', 'button');
    cancelButton.setAttribute('data-bs-dismiss', 'modal');
    cancelButton.textContent = this.cancelLabel;
    cancelButton.addEventListener('click', () => this.closeModal(modal));
    modalFooter.appendChild(cancelButton);

    const okButton = document.createElement('button');
    okButton.classList.add('btn', 'btn-primary');
    okButton.setAttribute('type', 'button');
    okButton.textContent = this.okLabel;
    okButton.addEventListener('click', () => {
      this.closeModal(modal);
      this.confirmed.emit();
    });
    modalFooter.appendChild(okButton);

    // Append the modal to the body and show it
    document.body.appendChild(modal);
    const bootstrapModal = new bootstrap.Modal(modal);
    bootstrapModal.show();

    // Cleanup when modal is closed
    modal.addEventListener('hidden.bs.modal', () => {
      modal.remove();
    });
  }

  closeModal(modal: HTMLElement) {
    const bootstrapModal = bootstrap.Modal.getInstance(modal);
    bootstrapModal?.hide();
  }
}
